export default function ManageAccessesScreen() {
  return null;
}
